import axios from "axios";
import { Toast } from "antd-mobile";
import pathToRegexp from 'path-to-regexp'
import { cloneDeep, isEmpty } from "lodash";
import qs from "qs";
// axios.defaults.baseURL = "http://192.168.0.150:8080/";
// axios.defaults.baseURL = "http://120.77.216.30/sdt/";
// axios.defaults.baseURL = "http://www.tietonggroup.com/sd";
// axios.defaults.baseURL = "http://120.77.151.17/sd";
export default function request (options) {
    // console.log(options);
    let { data, url, method = "get" } = options;
    const cloneData = cloneDeep(data);
    try {
        let domain = "";
        const urlMatch = url.match(/[a-zA-z]+:\/\/[^/]*/);
        if (urlMatch) {
            [domain] = urlMatch;
            url = url.slice(domain.length);
        }
        console.log(url);
        const match = pathToRegexp.parse(url);
        url = pathToRegexp.compile(url)(data);

        for (const item of match) {
            if (item instanceof Object && item.name in cloneData) {
                delete cloneData[item.name];
            }
        }
        url = domain + url;
    } catch (e) {

    }

    options.url =
        method.toLocaleLowerCase() === "get"
            ? `${url}${isEmpty(cloneData) ? "" : "?"}${qs.stringify(cloneData)}`
            : url;

    axios.defaults.baseURL = window.CONFIG_URL.baseURL;
    axios.defaults.withCredentials = true;
    //超时时间为60s
    axios.defaults.timeout = 30000;
    //响应拦截器

    axios.interceptors.request.use(
        config => {
            const token =
                sessionStorage.getItem("loginMsg") &&
                JSON.parse(sessionStorage.getItem("loginMsg")).token;
            const accessToken = sessionStorage.getItem("pc-access-token");
            const webSession = sessionStorage.getItem("manager-web-session");
            config.headers["pc-access-token"] = accessToken;
            config.headers["manager-web-session"] = webSession;
            config.params = {
                token: token,
                ...config.params,
            };
            Toast.loading("加载中...", 10);
            return config;
        },
        error => {
            return Promise.reject(error);
        },
    );

    axios.interceptors.response.use(
        response => {
            document.getElementById("root").scrollTop = 0;
            if (!response) {
                const res = { status: -100, message: "操作过于频繁", total: 0, data: {} }
                return Promise.resolve(res);
            }
            if (
                response.data &&
                response.data.data &&
                response.data.data.hasOwnProperty &&
                response.data.data.resultList
            ) {
                response.data.data.resultList =
                    response.data.data.resultList || [];
            }
            Toast.hide();
            if (response.status != 200) {
                switch (response.status) {
                    case 650:
                        Toast.fail(response.message);
                        break;
                    default:
                        break;
                }
            }
            if (response.data && (response.data.status == 397 || response.data.status == 403)) {
                //登录超时
                sessionStorage.removeItem("loginMsg");
                sessionStorage.removeItem("manager-web-session");
                sessionStorage.removeItem("pc-access-token");
                sessionStorage.removeItem("userListPage");
                window.location.reload();
            }

            return Promise.resolve(response);
        },
        error => {
            console.error(error);
            Toast.hide();
            Toast.info("操作失败", 1);
        },
    );
    return axios(options);
}
